import React, { useEffect, useState, useCallback } from 'react';
import { host_url } from '../../../App';
import BackArrow from '../../../BackArrow';
import '../../../styles/CiTable.css';
import './Ausschuesse.css';
import { MdKeyboardArrowDown } from 'react-icons/md';

function Ausschuesse() {
  const [ausschuesse, setAusschuesse] = useState([]);
  const [kinder, setKinder] = useState([]);
  const [zuordnungen, setZuordnungen] = useState([]);
  const [selectedAusschuss, setSelectedAusschuss] = useState(null);
  const [selectedKind, setSelectedKind] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const ladeAusschuesse = useCallback(() => {
    fetch(`${host_url}/ausschuesse`)
      .then((r) => r.json())
      .then(setAusschuesse)
      .catch(() => setError('Fehler beim Laden der Ausschüsse.'));
  }, []);

  const ladeZuordnungen = useCallback(() => {
    const url = selectedAusschuss
      ? `${host_url}/kinder_ausschuss?ausschussId=${selectedAusschuss}`
      : `${host_url}/kinder_ausschuss`;
    fetch(url)
      .then((r) => r.json())
      .then(setZuordnungen)
      .catch(() => setError('Fehler beim Laden der Zuordnungen.'));
  }, [selectedAusschuss]);

  const ladeKinder = useCallback(() => {
    fetch(`${host_url}/zeltsprecher`)
      .then((r) => r.json())
      .then(setKinder)
      .catch(() => {});
  }, []);

  useEffect(() => {
    ladeAusschuesse();
    ladeKinder();
  }, [ladeAusschuesse, ladeKinder]);

  useEffect(() => {
    ladeZuordnungen();
  }, [ladeZuordnungen, selectedAusschuss]);

  const kinderImAusschuss = selectedAusschuss
    ? zuordnungen.filter((z) => z.AusschussID === selectedAusschuss)
    : zuordnungen;

  // Zeltsprecher, die noch nicht im gewählten Ausschuss sind
  const verfuegbareKinder = selectedAusschuss
    ? kinder.filter(
        (k) =>
          !kinderImAusschuss.some((z) => z.KindID === k.KindID)
      )
    : kinder;

  const hinzufuegen = () => {
    if (!selectedKind || !selectedAusschuss) return;
    setSaving(true);
    setError('');
    fetch(`${host_url}/kinder_ausschuss`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ KindID: Number(selectedKind), AusschussID: Number(selectedAusschuss) }),
    })
      .then((r) => r.json())
      .then(() => {
        setSelectedKind('');
        setSuccessMsg('Kind erfolgreich zugeordnet.');
        setTimeout(() => setSuccessMsg(''), 3000);
        ladeZuordnungen();
      })
      .catch(() => setError('Fehler beim Zuordnen.'))
      .finally(() => setSaving(false));
  };

  const entfernen = (kindId, ausschussId) => {
    const kind = kinder.find((k) => k.KindID === kindId);
    if (!window.confirm(`„${kind?.Name || 'Kind'}" aus dem Ausschuss entfernen?`)) return;
    fetch(`${host_url}/kinder_ausschuss`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ KindID: kindId, AusschussID: ausschussId }),
    })
      .then(() => ladeZuordnungen())
      .catch(() => setError('Fehler beim Entfernen.'));
  };

  // Zuordnungen nach Ausschuss gruppieren (für Gesamtansicht)
  const gruppiertNachAusschuss = ausschuesse.map((a) => ({
    ...a,
    mitglieder: zuordnungen.filter((z) => z.AusschussID === a.AusschussID),
  }));

  const ausschussName = selectedAusschuss
    ? ausschuesse.find((a) => a.AusschussID === selectedAusschuss)?.Name
    : null;

  return (
    <div className="ausschuesse-page">
      <div className="page-header">
        <BackArrow to="/parlament" />
        <h1>Ausschüsse</h1>
      </div>

      {error && <div className="ausschuesse-error">{error}</div>}
      {successMsg && <div className="ausschuesse-success">{successMsg}</div>}

      {/* Übersicht: alle Ausschüsse als klickbare Karten */}
      {!selectedAusschuss ? (
        <div className="ausschuesse-liste">
          {gruppiertNachAusschuss.map((a) => (
            <div
              key={a.AusschussID}
              className="ausschuss-card ausschuss-card-clickable"
              onClick={() => { setSelectedAusschuss(a.AusschussID); setSelectedKind(''); }}
            >
              <h2 className="ausschuss-titel">
                <span className="material-symbols-outlined">groups</span>
                {a.Name}
                <span className="ausschuss-anzahl">{a.mitglieder.length} Mitglieder</span>
              </h2>
              {a.mitglieder.length === 0 ? (
                <p className="ausschuss-leer">Noch keine Kinder zugeordnet.</p>
              ) : (
                <ul className="ausschuss-mitglieder">
                  {a.mitglieder.map((m) => (
                    <li key={m.KindID} className="ausschuss-mitglied">
                      <span className="mitglied-name">{m.KindName}</span>
                      <span className="mitglied-zelt">{m.Zeltname}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      ) : (
        /* Detailansicht: gewählter Ausschuss mit Bearbeitung */
        <div className="ausschuss-detail">
          <button
            className="btn-back-ausschuss"
            onClick={() => { setSelectedAusschuss(null); setSelectedKind(''); }}
          >
            <span className="material-symbols-outlined">arrow_back</span>
            Alle Ausschüsse
          </button>

          <h2 className="ausschuss-titel">
            <span className="material-symbols-outlined">groups</span>
            {ausschussName}
            <span className="ausschuss-anzahl">{kinderImAusschuss.length} Mitglieder</span>
          </h2>

          {/* Kind hinzufügen */}
          <div className="ausschuesse-hinzufuegen">
            <label className="freitext-label">
              Zeltsprecher*in hinzufügen
              <div className="dropdown-wrapper" style={{ marginTop: '6px' }}>
                <select
                  value={selectedKind}
                  onChange={(e) => setSelectedKind(e.target.value)}
                >
                  <option value="">Zeltsprecher*in auswählen</option>
                  {verfuegbareKinder.map((k) => (
                    <option key={k.KindID} value={k.KindID}>
                      {k.Kindname} ({k.Zeltname})
                    </option>
                  ))}
                </select>
                <MdKeyboardArrowDown className="dropdown-chevron" />
              </div>
            </label>
            <button onClick={hinzufuegen} disabled={!selectedKind || saving}>
              {saving ? 'Wird zugeordnet…' : 'Zuordnen'}
            </button>
          </div>

          {/* Mitgliederliste */}
          {kinderImAusschuss.length === 0 ? (
            <p className="ausschuss-leer">Noch keine Kinder zugeordnet.</p>
          ) : (
            <ul className="ausschuss-mitglieder">
              {kinderImAusschuss.map((m) => (
                <li key={m.KindID} className="ausschuss-mitglied">
                  <span className="mitglied-name">{m.KindName}</span>
                  <span className="mitglied-zelt">{m.Zeltname}</span>
                  <button
                    className="btn-remove"
                    onClick={() => entfernen(m.KindID, m.AusschussID)}
                    title="Aus Ausschuss entfernen"
                  >
                    <span className="material-symbols-outlined">person_remove</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default Ausschuesse;
